// React i hookovi
import { memo, useCallback, useState } from "react";

// Tipovi specifični za komponentu


// UI komponente

// Lokalne komponente


// Pomoćne funkcije i hookovi
import { useTranslate } from "helpers";

// Konstante navigacije ili sidebar-a


import { VehicleInfoHeaderProps } from "./types";



const VehicleInfoHeader: React.FC<VehicleInfoHeaderProps> = (props) => {
    const { fleetVehicleDetail } = props;

    const { t } = useTranslate();

    const [showAddNewModal, setShowAddNewModal] = useState<boolean>(false);

    const handleEditSuccess = useCallback(() => {
        setShowAddNewModal(false);
    }, []);

    if (!fleetVehicleDetail.id) return <></>;

    return (
        <>
           
        </>
    );
};

export default memo(VehicleInfoHeader);
